<template>
  <el-button type="text" size="small" @click="getFileData">{{text}}</el-button>
</template>
<script>
import { GET_FILE_LINK } from '@/utils/api'
export default {
  name: 'file-download-button',

  props: {
    src: {
      type: String,
      required: true,
      default: ''
    },
    isUrl: {
      type: Boolean,
      required: false,
      default: false
    },
    text: {
      type: String,
      default: '下载'
    }
  },

  data () {
    return {
      url: ''
    }
  },

  watch: {
    src () {
      this.getUrl()
    }
  },

  created () {
    this.getUrl()
  },

  methods: {
    async getUrl () {
      if (this.isUrl) {
        return this.url = this.src
      }
      const res = await GET_FILE_LINK(this.src)
      this.url = res.data
    },

    async getFileData () {
      const res = await $get(this.url, {}, { responseType: 'blob' })
      if (res.status !== 200) { return }
      this.downloadFile(res.data)
    },

    downloadFile (data) {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([data]))
      link.download = this.src

      //此写法兼容可火狐浏览器
      document.body.appendChild(link)

      const evt = document.createEvent('MouseEvents')
      evt.initEvent('click', false, false)
      link.dispatchEvent(evt)
      window.URL.revokeObjectURL(link.href)
      document.body.removeChild(link)
    }
  }
}
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
</style>